import UserCardLoading from "./components/UserCardLoading";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";

const SingleChallengeLoading = () => {
  const loadingCards = Array(5).fill(null);
  return (
    <>
      <div className="skeleton rounded-md mt-4 mb-5 ">
        <p className="w-full rounded-md aspect-[375/222] object-cover"></p>
      </div>
      <p className="w-[60%] mb-4 h-6 ml-4 skeleton rounded-md"></p>
      <div className="m-4">
        <div className="flex w-full gap-1 mb-2 ">
          <p className="w-1/4 rounded-md skeleton h-2"></p>
          <p className="w-1/3 rounded-md  skeleton h-2"></p>
          <p className="w-1/4 skeleton rounded-md h-2"></p>
          <p className="w-1/2 rounded-md  skeleton h-2"></p>
          <p className="w-1/3 skeleton rounded-md h-2"></p>
        </div>
        <div className="flex w-full gap-1 mb-2 ">
          <p className="w-1/4 skeleton rounded-md h-2"></p>
          <p className="w-1/2 rounded-md skeleton h-2"></p>
          <p className="w-1/3 rounded-md  skeleton h-2"></p>
          <p className="w-1/4 skeleton rounded-md h-2"></p>
        </div>
        <div className="flex w-full gap-1 mb-2 ">
          <p className="w-1/5 rounded-md skeleton h-2"></p>
          <p className="w-1/3 rounded-md  skeleton h-2"></p>
          <p className="w-1/4 skeleton rounded-md h-2"></p>
          <p className="w-1/6 rounded-md  skeleton h-2"></p>
          <p className="w-1/2 skeleton rounded-md h-2"></p>
        </div>
        <div className="flex w-full gap-1 mb-2 ">
          <p className="w-1/4 skeleton rounded-md h-2"></p>
          <p className="w-1/2 rounded-md skeleton h-2"></p>
          <p className="w-1/4 rounded-md  skeleton h-2"></p>
          <p className="w-1/4 skeleton rounded-md h-2"></p>
        </div>
        <div className="flex w-full gap-1 mb-2 ">
          <p className="w-1/4 rounded-md skeleton h-2"></p>
          <p className="w-1/4 rounded-md  skeleton h-2"></p>
          <p className="w-1/4 skeleton rounded-md h-2"></p>
          <p className="w-1/2 rounded-md  skeleton h-2"></p>
          <p className="w-1/2 skeleton rounded-md h-2"></p>
        </div>
        <div className="flex w-full gap-1 mb-2 ">
          <p className="w-1/4 skeleton rounded-md h-2"></p>
          <p className="w-1/2 rounded-md skeleton h-2"></p>
          <p className="w-1/4 rounded-md  skeleton h-2"></p>
          <p className="w-1/4 skeleton rounded-md h-2"></p>
        </div>
        <div className="flex w-full gap-1 mb-2 ">
          <p className="w-1/4 rounded-md skeleton h-2"></p>
          <p className="w-1/3 rounded-md  skeleton h-2"></p>
          <p className="w-1/4 skeleton rounded-md h-2"></p>
          <p className="w-1/2 rounded-md  skeleton h-2"></p>
          <p className="w-1/2 skeleton rounded-md h-2"></p>
        </div>
        <div className="flex w-full gap-1 mb-2 ">
          <p className="w-1/4 skeleton rounded-md h-2"></p>
          <p className="w-1/2 rounded-md skeleton h-2"></p>
          <p className="w-1/3 rounded-md  skeleton h-2"></p>
          <p className="w-1/5 skeleton rounded-md h-2"></p>
        </div>
      </div>
      <div className="rounded-xl m-4 h-40 skeleton"></div>
      <div className="bg-white/08 m-4 rounded-xl border-b border-white/08 my-4 px-3 backdrop-blur-[10px]">
        <div className="flex-center-between py-3 border-b border-white/08 last-of-type:border-none">
          <p className="w-1/5 rounded-md h-3 skeleton"></p>
          <p className="h-3 w-1/3 skeleton rounded-md "></p>
        </div>
        <div className="flex-center-between py-3 border-b border-white/08 last-of-type:border-none">
          <p className="w-1/4 rounded-md h-3 skeleton"></p>
          <p className="h-3 w-1/2 skeleton rounded-md "></p>
        </div>
        <div className="flex-center-between py-3 border-b border-white/08 last-of-type:border-none">
          <p className="w-1/5 rounded-md h-3 skeleton"></p>
          <p className="h-3 w-1/4 skeleton rounded-md "></p>
        </div>
        <div className="flex-center-between py-3 border-b border-white/08 last-of-type:border-none">
          <p className="w-1/6 rounded-md h-3 skeleton"></p>
          <p className="h-3 w-1/3 skeleton rounded-md "></p>
        </div>

        <p className="p-2 h-9 skeleton rounded-xl bg-white/08 mb-3 flex-y-center gap-2 text-xs leading-130 font-normal text-white"></p>
      </div>
      <div className="grid gap-3 container">
        {loadingCards.map((_, index) => (
          <UserCardLoading key={index} />
        ))}
      </div>
      <VibratingButton className=" w-[93%]  h-10 skeleton rounded-xl m-4    "></VibratingButton>
    </>
  );
};

export default SingleChallengeLoading;
